<template>
  <div id="eventsContent">
    <div id="headerGroup">
      <div class="eventos-fondo-bloque">
        <img id="bgDinamic" src alt />
      </div>
      <section id="cabecera">
        <div class="container block eventos-contenedor">
          <div class="eventos-busqueda-contenedor">
            <div class="eventos-slider-contenedor">
              <div class="leyenda">
                <p class="text-1">Eventos</p>
                <p class="text-2">Aguascalientes</p>
              </div>
              <div id="slider" class="swiper-container">
                <div class="swiper-wrapper">
                  <div class="swiper-slide">
                    <img
                      id="img1"
                      :src="'https://eservicios2.aguascalientes.gob.mx/EventosPortal/img/IMG-20210804-WA0010.jpg'"
                      data-bg="1"
                      alt
                    />
                  </div>
                  <div class="swiper-slide">
                    <img
                      id="img2"
                      :src="'https://eservicios2.aguascalientes.gob.mx/EventosPortal/img/IMG-20210804-WA0011.jpg'"
                      data-bg="2"
                      alt
                    />
                  </div>
                  <div class="swiper-slide">
                    <img
                      id="img3"
                      :src="'https://eservicios2.aguascalientes.gob.mx/EventosPortal/img/IMG-20210804-WA0012.jpg'"
                      data-bg="3"
                      alt
                    />
                  </div>
                </div>
                <div class="swiper-pagination"></div>
              </div>
            </div>
            <!-- <Buscador @clicked="buscar"></Buscador> -->
          </div>
        </div>
      </section>
    </div>
    <!-- <section id="recomendados">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <h1 class="titulo-seccion mt-5">Eventos Destacados</h1>
            <div class="destacados-paginacion"></div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div id="recomendados-carrusel">
              <div class="swiper-wrapper">
                <div class="swiper-slide">
                  <div class="carta-evento">
                    <img
                      class="img-container"
                      src="https://via.placeholder.com/254x190"
                    />
                    <div class="info">
                      <p class="carta-evento-titulo">
                        Noche de Museo.
                        <br />Resultados del Taller Polos Audiovisuales
                      </p>
                      <p class="carta-evento-subtitulo">MUSEO ESPACIO</p>
                      <div class="carta-evento-fecha">
                        <p>4/29/2020</p>
                        <p>8:00 PM</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide">
                  <a href="#">
                    <div class="carta-evento">
                      <img
                        class="img-container"
                        src="https://via.placeholder.com/254x190"
                      />
                      <div class="info">
                        <p class="carta-evento-titulo">Titulo 2</p>
                        <p class="carta-evento-subtitulo">subtitulo 2</p>
                        <div class="carta-evento-fecha">8:00 PM</div>
                      </div>
                    </div>
                  </a>
                </div>
                <div class="swiper-slide">
                  <div class="carta-evento">
                    <img
                      class="img-container"
                      src="https://via.placeholder.com/254x190"
                    />
                    <div class="info">
                      <p class="carta-evento-titulo">Titulo 3</p>
                      <p class="carta-evento-subtitulo">subtitulo 3</p>
                      <div class="carta-evento-fecha">
                        <p>4/29/2020</p>
                        <p>8:00 PM</p>
                      </div>
                      <div class="carta-evento-fecha">
                        <p>4/29/2020</p>
                        <p>8:00 PM</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide">
                  <div class="carta-evento">
                    <img
                      class="img-container"
                      src="https://via.placeholder.com/254x190"
                    />
                    <div class="info">
                      <p class="carta-evento-titulo">Titulo 4</p>
                      <p class="carta-evento-subtitulo">subtitulo 4</p>
                      <div class="carta-evento-fecha">
                        <p>4/29/2020</p>
                        <p>8:00 PM</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section> -->
    <section id="proximos-container">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <h1 class="titulo-seccion mt-md-5">Próximos Eventos</h1>
          </div>
        </div>
        <Proximos :url="url" />
      </div>
    </section>
  </div>
</template>
<script>
import Proximos from "../components/proximos";
import Buscador from "../components/buscador";

//https://eservicios2.aguascalientes.gob.mx/geaws/api/gea/eve/ws/aut - nuevo
//https://egobierno2.aguascalientes.gob.mx/moviles/eventos/api/Datos - viejo
export default {
  name: "content2",
  data() {
    return {
      resp: [],
      idCategoria: null,
      url: "https://eservicios2.aguascalientes.gob.mx/geaws/api/gea/eve/ws/aut/",
    };
  },
  components: {
    Proximos,
    Buscador,
  },
  watch: {
    url: function (val) {
      this.url = val;
    },
  },
  mounted: function () {
    var mainSlide = new Swiper(".swiper-container", {
      pagination: {
        el: ".swiper-pagination",
        dynamicBullets: true,
      },
      updateOnWindowResize: true,
      autoplay: {
        delay: 5000,
      },
      speed: 700,
      effect: "slide",
      fadeEffect: {
        crossFade: true,
      },
    });

    var imgBg = document.querySelector(".swiper-slide-active img").src;
    document.getElementById("bgDinamic").src = imgBg;

    mainSlide.on("transitionEnd", function () {
      var imgBg = document.querySelector(".swiper-slide-active img").src;
      document.getElementById("bgDinamic").src = imgBg;

      var fade = document.getElementById("bgDinamic");
      fade.classList.add("fade");
      setTimeout(function () {
        fade.classList.remove("fade");
      }, 500);
    });
  },
  methods: {
    buscar(elem) {
      this.url = elem;
    },
  },
};
</script>
